/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Activity_Center_Errors_RepeatedInputs */



/**
* | output |
* | --- |
* | "{count}×" |
*
* @param {Activity_Center_Errors_RepeatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_center_errors_repeated = /** @type {((inputs: Activity_Center_Errors_RepeatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Center_Errors_RepeatedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}×`)
	return /** @type {LocalizedString} */ (`${i?.count}×`)
});